import { useNavigate } from 'react-router-dom'
import React, { useState } from 'react'
import LogoHeader from './header/LogoHeader'

export default function ContactUs() {
  const navigate = useNavigate()
  const handleBackButton = (event) => {
    event.preventDefault()
    navigate('/homepage')
  }

  return (
    <>
      <LogoHeader />
      <div className="card m-3">
        <div className="card-header bg-white text-black" style={{ fontSize: '25px' }}>
          <b>Contact Us</b>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-sm-5 mb-3" style={{ fontSize: '20px' }}>
              <b>Query Type</b>
            </div>
            <div className="col-sm-7" style={{ fontSize: '20px' }}>
              <b>How to Contact?</b>
            </div>
            <hr />
            <div className="col-sm-5 mt-2" style={{ fontSize: '18px' }}>
              Login or Registration related issues or any technical issues.
            </div>
            <div className="col-sm-7 mt-2" style={{ fontSize: '18px' }}>
              <a style={{ textDecoration: 'none' }}>
                <b>Please feel free to call us at the numbers provided.</b>
              </a>
              <br />
              <br />
              <b>IT & Technical (Form Filling)</b>
              <br />
      
              Phone - 1744-(225803) (For technical issues on all working days from 9 AM to 6 PM)
              <br />
              Email -
              <a style={{ textDecoration: 'none',color:'blueviolet'}}>
                <b> counsellingtechnicalqueries@gmail.com</b>
              </a>
              <br />
              <br />
              <b>For Counselling Related Issues</b>
              <br />
              Email - 
              <a style={{ textDecoration: 'none',color:'blueviolet' }}>
                <b> gr.skau.hry@gmail.com </b>
              </a>
              <br />
              Phone - 1744-(225803)
              <br />
              <br />
            </div>
          </div>
          <h4 className="card-title m-b-0">Important Note</h4>
          <ul>
            <li>Candidate must read the Prospectus carefully for admissions to BAMS/BHMS or MD/MS (Ayurveda) for the session 2026-27 carefully and follow the schedule</li>
            <li>Shri Krishna Ayush University,Haryana cannot assure resolution to queries the raised on last day of respective event in the schedule</li>
            <li>If you have already registered, please raise a ticket in help desk to have better tracking of your request.</li>
          </ul>
        </div>
      </div>
      <div className="d-flex justify-content-center" style={{ marginBottom: 100 }}>
        <button className="btn btn-success text-white" onClick={handleBackButton}>
          {'<<< Back'}
        </button>
      </div>
    </>
  )
}